import stringifyAttributes from '../helpers/stringifyAttributes';

export default function () {
    return {
        restrict: 'E',
        template(el, attrs) {
            const children = el[0].textContent;
            const propsString = stringifyAttributes(attrs);

            return `
                <label class="pointer">
                    <input type="radio" class="hide" ${ propsString }>
                    <i class="icon material-icons unchecked">&#xE836;</i>
                    <i class="icon material-icons checked hide">&#xE837;</i>
                    ${ children }
                </label>
            `;
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/radio.js